<template>
  <div class="chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>  

<script>
import { Line } from 'vue-chartjs';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';

export default {
  extends: Line,
  mounted() {
    const colors = [
      'rgba(75, 192, 192, 1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(255, 99, 132, 1)',
      'rgba(153, 102, 255, 1)'
    ];

    const generateRandomData = () => {
      return Array.from({ length: 8 }, () => Math.floor(Math.random() * 500));
    };

    this.renderChart({
      labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
      datasets: [
        {
          borderColor: colors[0],
          backgroundColor: 'transparent',
          data: generateRandomData(),
          fill: false,
          pointBackgroundColor: colors[0],
          borderWidth: 1,
          tension: 0
        },
        {
          borderColor: colors[1],
          backgroundColor: 'transparent',
          data: generateRandomData(),
          fill: false,
          pointBackgroundColor: colors[1],
          borderWidth: 1,
          tension: 0
        },
        {
          borderColor: colors[2],
          backgroundColor: 'transparent',
          data: generateRandomData(),
          fill: false,
          pointBackgroundColor: colors[2],
          borderWidth: 1,
          tension: 0
        },
        {
          borderColor: colors[3],
          backgroundColor: 'transparent',
          data: generateRandomData(),
          fill: false,
          pointBackgroundColor: colors[3],
          borderWidth: 1,
          tension: 0
        },
        {
          borderColor: colors[4],
          backgroundColor: 'transparent',
          data: generateRandomData(),
          fill: false,
          pointBackgroundColor: colors[4],
          borderWidth: 1,
          tension: 0
        },
        {
          borderColor: colors[5],
          backgroundColor: 'transparent',
          data: generateRandomData(),
          fill: false,
          pointBackgroundColor: colors[5],
          borderWidth: 1,
          tension: 0
        },
        {
          borderColor: colors[6],
          backgroundColor: 'transparent',
          data: generateRandomData(),
          fill: false,
          pointBackgroundColor: colors[6],
          borderWidth: 1,
          tension: 0
        }
      ]
    }, {
      responsive: true,
      maintainAspectRatio: true,
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor };
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)'
          },
          ticks: {
            fontColor: '#000'
          }
        }],
        yAxes: [{
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)'
          },
          ticks: {
            fontColor: '#000'
          }
        }]
      }
    });
  }
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%; /* 고정된 높이를 제거 */
  position: relative;
  padding-bottom: 50%; /* 2:1 비율을 유지하기 위한 패딩 */
}
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>
